import { Button, RadioGroup, Switch } from 'devextreme-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, CardFooter, Col, Row } from 'reactstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import erorSound from '../../assets/audio/alert-error.wav';
import warningSound from '../../assets/audio/alert-warning.wav';
import Breadcrumb from '../../components/common/breadcrumb';
import SorgulamaEkrani from '../../components/common/sorgulama-component/sorgulama-ekrani';
import { printLabel } from '../../utils/LabelService';
import useFormatMessage from '../../utils/useFormatMessage';
import HasarBildirimiAddModal from '../hasar-bildirimi/components/HasarBildirimiAddModal';

const PDIComponent = ({ title, radioItems, defaultRadio, showSwitch, api, modalArea, minCharacter, depo, role_name }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useFormatMessage();
    const [dataSource, setDataSource] = useState(null);

    // Switch state sadece PDI Çıkış için
    const [printEnabled, setPrintEnabled] = useState(true);
    const isPDIExit = title === "PDI Çıkış";

    const notify = (message) => toast.error(`${message}`);
    const notifySuccess = (message) => {
        toast.success(message, {
            autoClose: 1000,
            position: "top-right",
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true
        });
    };

    useEffect(() => {
        if (!dataSource) return;

        const handleResponse = async () => {
            // Hata durumu
            if (dataSource?.success === false) {
                if (navigator.vibrate) {
                    navigator.vibrate(500);
                }
                const errorSound = document.getElementById("errorSound");
                errorSound.play();

                let error = dataSource?.message ? t(dataSource?.message) : t(dataSource?.error) ? t(dataSource?.error) : t("Bir hata oluştu!");
                let adres = dataSource.data ? dataSource.data.ZoneName + " " + dataSource.data.AddressCode : null;

                Swal.fire({
                    icon: 'error',
                    title: 'Hata',
                    html: `<div style="font-size: 24px;">${error.replaceAll("chassis", "Şase").replaceAll("is in an inactive groupage", "aktif bir grupajda değil.")}</div>
                    ${adres ? ` <br/><div style="margin-top: 15px;"><strong>${adres}</strong></div>` : ''}`,
                    showConfirmButton: true,
                    confirmButtonText: 'Tamam',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    background: '#fff5f5',
                    customClass: {
                        popup: 'swal2-popup-large'
                    }
                });
            }
            // Uyarı durumu
            else if (dataSource?.warning) {
                const warningSound = document.getElementById("warningSound");
                warningSound.play();

                await Swal.fire({
                    title: '⚠️',
                    html: `<div style="font-size: 24px;">
                        <div style="color: red !important; font-weight: 700; font-size: 2.5rem; padding: 10px; background: #ffdb9a; margin-top: 10px; border-radius: 10px;">${dataSource.warning.info}</div>
                        <div style="color:green; font-weight:700; margin-top: 10px;">
                            <span>✔</span> İşlem başarılı!
                        </div>
                        ${dataSource.address ? `
                            <div style="margin-top: 15px; color: #28a745;">
                                ${dataSource.address.address_code}
                            </div>
                        ` : ''}
                    </div>`,
                    showConfirmButton: true,
                    confirmButtonText: 'Tamam',
                    confirmButtonColor: '#ffc107',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    customClass: {
                        popup: 'swal2-popup-large'
                    }
                });
                // PDI Çıkış ise ve başarılı ise etiket yazdır
                if (isPDIExit && printEnabled) {
                    const chassisInput = document.getElementById("Entity_Sase");
                    if (chassisInput && chassisInput.value) {
                        await new Promise(resolve => setTimeout(resolve, 400));
                        await printLabel(chassisInput.value);
                    }
                }
            }
            // Başarılı durumu
            else if (dataSource?.success === true) {
                if (dataSource.address || dataSource?.data) {
                    let adress = typeof dataSource.address === 'string' ? dataSource.address :
                        dataSource.address?.address_code ? dataSource.address.address_code :
                            (dataSource.data ? `${dataSource.data.ZoneName} ${dataSource.data.AddressCode}` : '');
                    let groupNo = dataSource.data?.GroupageNo;

                    await Swal.fire({
                        icon: 'success',
                        html: `<div style="font-size: 24px;">
                            <b>${adress}</b>
                            ${groupNo ? `<br/><span style="font-size: 20px;">Grupaj No: ${groupNo}</span>` : ''}
                        </div>`,
                        timer: 3000,
                        showConfirmButton: false,
                        position: 'center',
                        allowOutsideClick: false,
                        customClass: {
                            popup: 'swal2-popup-large'
                        }
                    });
                    // PDI Çıkış ise ve başarılı ise etiket yazdır
                    if (isPDIExit && printEnabled) {
                        const chassisInput = document.getElementById("Entity_Sase");
                        if (chassisInput && chassisInput.value) {
                            await new Promise(resolve => setTimeout(resolve, 500));
                            await printLabel(chassisInput.value);
                        }
                    }

                    const input = document.querySelector('input[type="text"]');
                    if (input) {
                        input.value = '';
                        input.focus();
                    }
                } else {
                    notifySuccess("Başarılı");
                }
            }
        };

        handleResponse();
    }, [dataSource]);

    return (
        <div>
            <audio id="errorSound" src={erorSound} preload="auto"></audio>
            <audio id="warningSound" src={warningSound} preload="auto"></audio>
            <Breadcrumb current={t(title)} depo={depo} />
            <Card>
                <Row className='m-3'>
                    <Col md="12">
                        <RadioGroup
                            id='HasarBildir'
                            items={radioItems}
                            defaultValue={defaultRadio}
                            stylingMode='outlined'
                            layout='horizontal'
                            itemRender={(data) => (
                                <div>
                                    <span>{t(data)}</span>
                                </div>
                            )}
                            onValueChange={(e) => {
                                if (e === "Hasar Bildir") {
                                    document.querySelector('.hasar-bildirimi').style.display = "block";
                                } else {
                                    document.querySelector('.hasar-bildirimi').style.display = "none";
                                }
                            }}
                        />
                    </Col>
                </Row>
                {/* Switch sadece PDI Çıkış için gösterilir */}
                {isPDIExit && showSwitch && (
                    <Row className='m-3'>
                        <Col md="12">
                            <span style={{ fontWeight: "600" }}>{t("Etiket Yazdır")}&emsp;</span>
                            <Switch
                                width={100}
                                defaultValue={true}
                                onValueChanged={(e) => setPrintEnabled(e.value)}
                            />
                        </Col>
                    </Row>
                )}
                <SorgulamaEkrani
                    apiEndpoint={api}
                    setData={setDataSource}
                    minCharacter={minCharacter}
                    role_name={role_name}
                    title={title}
                />
                <CardFooter style={{
                    textAlign: "right",
                    color: "red",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "flex-end"
                }}>
                    <Button onClick={() => {
                        if (document.getElementById("Entity_Sase").value.length < 17) {
                            notify(t("17 karakterli şase numarası giriniz"))
                        }
                        else setIsOpen(!isOpen)
                    }} className='hasar-bildirimi' style={{ display: "none", width: "max-content", padding: "5px", color: "white", background: "#ff4040" }}>
                        <i>
                            {t("Hasar Bildir")}
                        </i>
                    </Button>
                </CardFooter>
            </Card>
            <HasarBildirimiAddModal isOpen={isOpen} setIsOpen={setIsOpen} area={modalArea} />

            <style>
                {`
                    .swal2-popup-large {
                        width: 600px !important;
                    }
                    .swal2-title {
                        font-size: 28px !important;
                    }
                    .swal2-html-container {
                        font-size: 24px !important;
                        margin: 1em 0 !important;
                    }
                `}
            </style>
        </div>
    );
};

export default PDIComponent;